/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// $('.ad_to_cart_coll').click(function(){    
//   var ID = $(this).attr("data-var_id");
//   addItemToCart( ID, 1);    // paste your id product number
//   $('.cart_dr').trigger( "click" );
// });
// function addItemToCart(variant_id, qty) {
//   data = {
//     "id": variant_id,
//     "quantity": qty
//   }
//   jQuery.ajax({
//     type: 'POST',
//     url: '/cart/add.js',
//     data: data,
//     dataType: 'json',
//     success: function() { 
//       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//         bubbles: true  //this code is for prestige theme, is to refresh the cart
//       }));
//     }   
    
//   }); 
 
// }


// Filter by Default first Select In Collection's

(function () {
  var filter1 = document.getElementById("sidebar-filter-v-availability1");
  var filter2 = document.getElementById("sidebar-filter-v-availability0");

  // Exit if neither filter element exists (homepage, product, cart, etc.)
  if (!filter1 && !filter2) return;

  // Don't run on search pages
  if (window.location.href.includes("search")) return;

  // Get the section ID for the Section Rendering API
  var sectionEl = document.querySelector("[data-section-id]");
  if (!sectionEl) return;
  var sectionId = sectionEl.getAttribute("data-section-id");

  var productContainer = document.querySelector(".CollectionInner__Products");
  if (!productContainer) return;

  // Fetch filtered products via Section Rendering API and swap the grid
  function fetchFilteredProducts(url) {
    var fetchUrl = new URL(url);
    fetchUrl.searchParams.set("section_id", sectionId);

    return fetch(fetchUrl.toString())
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var newContent = doc.querySelector(".CollectionInner__Products");
        if (newContent) {
          productContainer.innerHTML = newContent.innerHTML;
        }
      })
      .catch(function (err) {
        console.error("[availability-filter] Fetch failed:", err);
      });
  }

  // Apply a filter value, update URL, and fetch new content
  function applyFilter(value, useReplaceState) {
    var url = new URL(window.location.href);
    url.searchParams.delete("filter.v.availability");
    url.searchParams.set("filter.v.availability", value);

    if (useReplaceState) {
      history.replaceState(null, "", url.toString());
    } else {
      history.pushState(null, "", url.toString());
    }
    return fetchFilteredProducts(url.toString());
  }

  // Sync radio button UI with the current URL
  function syncFilterUI() {
    var href = window.location.href;
    if (filter1) filter1.checked = href.includes("filter.v.availability=1");
    if (filter2) filter2.checked = href.includes("filter.v.availability=0");
  }

  // DEFAULT: First visit to collection with no filter → apply in-stock silently
  if (!window.location.href.includes("filter.v.availability")) {
    applyFilter("1", true);
    syncFilterUI();
  }

  // Only enable the filter button that has results (matches old size_filter logic)
  var size_filter = filter1 ? filter1.getAttribute("filter_size") : 0;

  // Click: In Stock (only if there are in-stock products)
  if (filter1 && size_filter >= 1) {
    filter1.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      applyFilter("1", false);
      syncFilterUI();
    });
  }

  // Click: Out of Stock (only if all products are out of stock)
  if (filter2 && size_filter == 0) {
    filter2.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      applyFilter("0", false);
      syncFilterUI();
    });
  }

  // Handle browser back/forward navigation
  window.addEventListener("popstate", function () {
    if (!window.location.href.includes("search")) {
      fetchFilteredProducts(window.location.href);
      syncFilterUI();
    }
  });
})();
